import { ScrollRestoration } from "react-router-dom";
import PublicLayout from "../layout/PublicLayout/PublicLayout";
import PrivateRoutes from "./PrivateRoute";

const PublicRoutes = () => {
    const authLogin = localStorage.getItem("parent_token")
    if (authLogin) return <PrivateRoutes/>

    return (
        <>
        <ScrollRestoration/>
        <PublicLayout/>
        </>
    )
}

export default PublicRoutes;
